// extracted by css-extract-rspack-plugin
module.exports =  {"animatedIcon":"AnimatedIcon-m__animatedIcon___aTkD_"};